import { SPONSORED_SHEET_TAG } from "./consts.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function ensureSponsoredSheet(): void {
  if (typeof document === "undefined") return;
  if (document.querySelector(SPONSORED_SHEET_TAG)) return;

  document.body.appendChild(document.createElement(SPONSORED_SHEET_TAG));
}
